import React, { useState } from "react";
import { Button, Space, Modal } from "antd";
import { FaInstagram } from "react-icons/fa";

const PRESSEPAKET_ENABLED = false;

// Contact details assembled at runtime — prevents static HTML crawlers from
// harvesting them. charCode 64 = '@', '\u00A0' = non-breaking space.
const at = String.fromCharCode(64);
const nbsp = "\u00A0";
const EMAIL = ["info", "saxemble.de"].join(at);
const PHONE_DISPLAY = ["0170", "201", "5692"].join(nbsp);
const PHONE_HREF = "tel:+491702015692";

function AppFooter() {
  const [modal1Open, setModal1Open] = useState(false);
  const [modal2Open, setModal2Open] = useState(false);
  const [modal3Open, setModal3Open] = useState(false);

  return (
    <div className="container-fluid">
      <div className="footer">
        <img
          src="/images/logo_saxemble_transparent.png"
          alt="sax'emble Logo"
          className="logoImage"
          height="55"
        />

        <ul className="socials">
          <li>
            <a
              href="https://www.instagram.com/saxemble_schoental"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="sax'emble auf Instagram"
            >
              <FaInstagram size={26} />
            </a>
          </li>
        </ul>

        <Space wrap justify="center">
          <Button
            type="primary"
            size="small"
            onClick={() => setModal1Open(true)}
          >
            Downloads
          </Button>
          <Button
            type="primary"
            size="small"
            onClick={() => setModal2Open(true)}
          >
            Impressum
          </Button>
          <Button
            type="primary"
            size="small"
            onClick={() => setModal3Open(true)}
          >
            Datenschutzerklärung
          </Button>
        </Space>

        <div className="copyright">
          © {new Date().getFullYear()} sax'emble Saxophonorchester Kloster
          Schöntal
          <br />
          <span style={{ fontSize: 12, opacity: 0.6 }}>
            erstellt von Theresa Zürn und Jonathan Diebel
          </span>
        </div>
      </div>

      {/* Downloads Modal */}
      <Modal
        title="Downloads"
        centered
        open={modal1Open}
        onCancel={() => setModal1Open(false)}
        footer={null}
      >
        <div className="modalContent">
          {PRESSEPAKET_ENABLED && (
            <>
              <p>
                <strong>Presse-Paket:</strong>
              </p>
              <div>
                <a
                  href="/downloads/Presse-Paket.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Presse-Paket herunterladen
                </a>
              </div>
            </>
          )}
          <p style={{ marginTop: 24 }}>
            <strong>Vereinssatzung:</strong>
          </p>
          <div>
            <a
              href="/downloads/Vereinssatzung.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Vereinssatzung herunterladen
            </a>
          </div>
        </div>
      </Modal>

      {/* Impressum Modal */}
      <Modal
        title="Impressum"
        centered
        open={modal2Open}
        onCancel={() => setModal2Open(false)}
        footer={null}
      >
        <p>
          <strong>Angaben gemäß § 5 TMG und § 18 Abs. 2 MStV:</strong>
        </p>
        <p>
          Sax'emble Saxophonorchester Kloster Schöntal
          <br />
          (nicht eingetragener Verein)
        </p>
        <p>
          <strong>Vertreten durch den Vorstand:</strong>
          <br />
          Marcel Möhler
          <br />
          Klosterhof 1
          <br />
          74214 Schöntal
        </p>
        <p>
          <strong>Kontakt:</strong>
          <br />
          Telefon: <a href={PHONE_HREF}>{PHONE_DISPLAY}</a>
          <br />
          E-Mail: <a href={"mailto:" + EMAIL}>{EMAIL}</a>
        </p>
        <p>
          <strong>Haftungsausschluss:</strong>
          <br />
          Das Sax'emble Saxophonorchester übernimmt keine Haftung für die
          Richtigkeit der auf dieser Website aufrufbaren Beiträge.
          Gesetzeswidrige Informationen werden unverzüglich entfernt, sobald der
          Verein Kenntnis davon erlangt hat.
        </p>
        <p>
          <strong>Urheberrecht:</strong>
          <br />
          Sämtliche Texte, Bilder sowie Musikbeispiele und andere auf der
          Internetseite veröffentlichten Werke unterliegen – sofern nicht anders
          gekennzeichnet – dem Urheberrecht des Vereins. Jede Vervielfältigung,
          Verbreitung, Speicherung und Weitergabe der Inhalte ist ohne
          schriftliche Genehmigung des Sax'emble Saxophonorchesters Kloster
          Schöntal ausdrücklich untersagt.
        </p>
      </Modal>

      {/* Datenschutzerklärung Modal */}
      <Modal
        title="Datenschutzerklärung"
        centered
        open={modal3Open}
        onCancel={() => setModal3Open(false)}
        footer={null}
        width={640}
      >
        <h2>1. Datenschutz auf einen Blick</h2>
        <h3>Allgemeine Hinweise</h3>
        <p>
          Die folgenden Hinweise geben einen einfachen Überblick darüber, was
          mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website
          besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie
          persönlich identifiziert werden können. Ausführliche Informationen zum
          Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten
          Datenschutzerklärung.
        </p>

        <h3>Datenerfassung auf dieser Website</h3>
        <p>
          <strong>
            Wer ist verantwortlich für die Datenerfassung auf dieser Website?
          </strong>
          <br />
          Die Datenverarbeitung auf dieser Website erfolgt durch den
          Websitebetreiber. Dessen Kontaktdaten können Sie dem Abschnitt
          „Hinweis zur Verantwortlichen Stelle“ in dieser Datenschutzerklärung
          entnehmen.
        </p>
        <p>
          <strong>Wie erfassen wir Ihre Daten?</strong>
          <br />
          Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese
          mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie in ein
          Kontaktformular eingeben. Andere Daten werden automatisch oder nach
          Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme
          erfasst. Das sind vor allem technische Daten (z. B. Internetbrowser,
          Betriebssystem oder Uhrzeit des Seitenaufrufs).
        </p>
        <p>
          <strong>Wofür nutzen wir Ihre Daten?</strong>
          <br />
          Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung
          der Website zu gewährleisten. Andere Daten können zur Bearbeitung
          Ihrer Anfragen genutzt werden.
        </p>
        <p>
          <strong>Welche Rechte haben Sie bezüglich Ihrer Daten?</strong>
          <br />
          Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft,
          Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu
          erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung
          dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur
          Datenverarbeitung erteilt haben, können Sie diese Einwilligung
          jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht,
          unter bestimmten Umständen die Einschränkung der Verarbeitung Ihrer
          personenbezogenen Daten zu verlangen. Des Weiteren steht Ihnen ein
          Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
        </p>

        <h2>2. Hosting</h2>
        <h3>Externes Hosting</h3>
        <p>
          Diese Website wird extern gehostet. Die personenbezogenen Daten, die
          auf dieser Website erfasst werden, werden auf den Servern des Hosters
          gespeichert. Hierbei kann es sich v. a. um IP-Adressen,
          Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten,
          Kontaktdaten, Namen, Websitezugriffe und sonstige Daten, die über eine
          Website generiert werden, handeln.
        </p>
        <p>
          Das externe Hosting erfolgt zum Zwecke der Vertragserfüllung gegenüber
          unseren potenziellen und bestehenden Kunden (Art. 6 Abs. 1 lit. b
          DSGVO) und im Interesse einer sicheren, schnellen und effizienten
          Bereitstellung unseres Online-Angebots durch einen professionellen
          Anbieter (Art. 6 Abs. 1 lit. f DSGVO).
        </p>
        <p>Wir setzen folgenden Hoster ein:</p>
        <p>
          <strong>TrafficPlex GmbH</strong>
          <br />
          Konsul-Smidt-Str. 90
          <br />
          28217 Bremen, Deutschland
        </p>
        <p>
          <strong>Auftragsverarbeitung</strong>
          <br />
          Wir haben einen Vertrag über Auftragsverarbeitung (AVV) mit dem oben
          genannten Anbieter geschlossen. Hierbei handelt es sich um einen
          datenschutzrechtlich vorgeschriebenen Vertrag, der gewährleistet, dass
          dieser die personenbezogenen Daten unserer Websitebesucher nur nach
          unseren Weisungen und unter Einhaltung der DSGVO verarbeitet.
        </p>

        <h2>3. Allgemeine Hinweise und Pflichtinformationen</h2>
        <h3>Datenschutz</h3>
        <p>
          Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten
          sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und
          entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser
          Datenschutzerklärung. Wenn Sie diese Website benutzen, werden
          verschiedene personenbezogene Daten erhoben. Personenbezogene Daten
          sind Daten, mit denen Sie persönlich identifiziert werden können. Die
          vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben
          und wofür wir sie nutzen. Sie erläutert auch, wie und zu welchem Zweck
          das geschieht.
        </p>

        <h3>Hinweis zur verantwortlichen Stelle</h3>
        <p>
          Die verantwortliche Stelle für die Datenverarbeitung auf dieser
          Website ist:
        </p>
        <p>
          Sax'emble Saxophonorchester Kloster Schöntal (nicht eingetragener
          Verein)
          <br />
          Vertreten durch: Marcel Möhler
          <br />
          Klosterhof 1<br />
          74214 Schöntal
          <br />
          Telefon: <a href={PHONE_HREF}>{PHONE_DISPLAY}</a>
          <br />
          E-Mail: <a href={"mailto:" + EMAIL}>{EMAIL}</a>
        </p>

        <h3>Speicherdauer</h3>
        <p>
          Soweit innerhalb dieser Datenschutzerklärung keine speziellere
          Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten
          bei uns, bis der Zweck für die Datenverarbeitung entfällt. Wenn Sie
          ein berechtigtes Löschersuchen geltend machen oder eine Einwilligung
          zur Datenverarbeitung widerrufen, werden Ihre Daten gelöscht, sofern
          wir keine anderen rechtlich zulässigen Gründe für die Speicherung
          Ihrer personenbezogenen Daten haben (z. B. steuer- oder
          handelsrechtliche Aufbewahrungsfristen); im letztgenannten Fall
          erfolgt die Löschung nach Fortfall dieser Gründe.
        </p>

        <h3>Empfänger von personenbezogenen Daten</h3>
        <p>
          Im Rahmen unserer Geschäftstätigkeit arbeiten wir mit verschiedenen
          externen Stellen zusammen. Dabei ist teilweise auch eine Übermittlung
          von personenbezogenen Daten an diese externen Stellen erforderlich.
          Wir geben personenbezogene Daten nur dann an externe Stellen weiter,
          wenn dies im Rahmen einer Vertragserfüllung erforderlich ist, wenn wir
          gesetzlich hierzu verpflichtet sind, wenn wir ein berechtigtes
          Interesse nach Art. 6 Abs. 1 lit. f DSGVO an der Weitergabe haben oder
          wenn eine sonstige Rechtsgrundlage die Datenweitergabe erlaubt. Beim
          Einsatz von Auftragsverarbeitern geben wir personenbezogene Daten
          unserer Kunden nur auf Grundlage eines gültigen Vertrags über
          Auftragsverarbeitung weiter.
        </p>

        <h3>Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
        <p>
          Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen
          Einwilligung möglich. Sie können eine bereits erteilte Einwilligung
          jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf
          erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
        </p>

        <h3>
          Widerspruchsrecht gegen die Datenerhebung in besonderen Fällen sowie
          gegen Direktwerbung (Art. 21 DSGVO)
        </h3>
        <p>
          WENN DIE DATENVERARBEITUNG AUF GRUNDLAGE VON ART. 6 ABS. 1 LIT. E ODER
          F DSGVO ERFOLGT, HABEN SIE JEDERZEIT DAS RECHT, AUS GRÜNDEN, DIE SICH
          AUS IHRER BESONDEREN SITUATION ERGEBEN, GEGEN DIE VERARBEITUNG IHRER
          PERSONENBEZOGENEN DATEN WIDERSPRUCH EINZULEGEN. WENN SIE WIDERSPRUCH
          EINLEGEN, WERDEN WIR IHRE BETROFFENEN PERSONENBEZOGENEN DATEN NICHT
          MEHR VERARBEITEN, ES SEI DENN, WIR KÖNNEN ZWINGENDE SCHUTZWÜRDIGE
          GRÜNDE FÜR DIE VERARBEITUNG NACHWEISEN, DIE IHRE INTERESSEN, RECHTE
          UND FREIHEITEN ÜBERWIEGEN ODER DIE VERARBEITUNG DIENT DER
          GELTENDMACHUNG, AUSÜBUNG ODER VERTEIDIGUNG VON RECHTSANSPRÜCHEN
          (WIDERSPRUCH NACH ART. 21 ABS. 1 DSGVO).
        </p>

        <h3>Beschwerderecht bei der zuständigen Aufsichtsbehörde</h3>
        <p>
          Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein
          Beschwerderecht bei einer Aufsichtsbehörde, insbesondere in dem
          Mitgliedstaat ihres gewöhnlichen Aufenthalts, ihres Arbeitsplatzes
          oder des Orts des mutmaßlichen Verstoßes zu. Für uns ist zuständig:
          Der Landesbeauftragte für den Datenschutz und die Informationsfreiheit
          Baden-Württemberg (www.baden-wuerttemberg.datenschutz.de).
        </p>

        <h3>Recht auf Datenübertragbarkeit</h3>
        <p>
          Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung
          oder in Erfüllung eines Vertrags automatisiert verarbeiten, an sich
          oder an einen Dritten in einem gängigen, maschinenlesbaren Format
          aushändigen zu lassen. Sofern Sie die direkte Übertragung der Daten an
          einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es
          technisch machbar ist.
        </p>

        <h3>Auskunft, Berichtigung und Löschung</h3>
        <p>
          Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit
          das Recht auf unentgeltliche Auskunft über Ihre gespeicherten
          personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck
          der Datenverarbeitung und ggf. ein Recht auf Berichtigung oder
          Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema
          personenbezogene Daten können Sie sich jederzeit an uns wenden.
        </p>

        <h3>Recht auf Einschränkung der Verarbeitung</h3>
        <p>
          Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer
          personenbezogenen Daten zu verlangen. Hierzu können Sie sich jederzeit
          an uns wenden.
        </p>

        <h3>SSL- bzw. TLS-Verschlüsselung</h3>
        <p>
          Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der
          Übertragung vertraulicher Inhalte, wie zum Beispiel Anfragen, die Sie
          an uns als Seitenbetreiber senden, eine SSL- bzw. TLS-Verschlüsselung.
          Eine verschlüsselte Verbindung erkennen Sie daran, dass die
          Adresszeile des Browsers von „http://“ auf „https://“ wechselt und an
          dem Schloss-Symbol in Ihrer Browserzeile. Wenn die SSL- bzw.
          TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie an uns
          übermitteln, nicht von Dritten mitgelesen werden.
        </p>

        <h2>4. Datenerfassung auf dieser Website</h2>
        <h3>Server-Log-Dateien</h3>
        <p>
          Der Provider der Seiten erhebt und speichert automatisch Informationen
          in so genannten Server-Log-Dateien, die Ihr Browser automatisch an uns
          übermittelt. Dies sind: Browsertyp und Browserversion, verwendetes
          Betriebssystem, Referrer URL, Hostname des zugreifenden Rechners,
          Uhrzeit der Serveranfrage, IP-Adresse.
        </p>
        <p>
          Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht
          vorgenommen. Die Erfassung dieser Daten erfolgt auf Grundlage von Art.
          6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes
          Interesse an der technisch fehlerfreien Darstellung und der
          Optimierung seiner Website – hierzu müssen die Server-Log-Files
          erfasst werden.
        </p>

        <h3>Keine Cookies</h3>
        <p>
          Diese Website verwendet <strong>keine Cookies</strong>. Es werden
          weder eigene noch Drittanbieter-Cookies gesetzt zur Nachverfolgung,
          Analyse oder Werbung.
        </p>

        <h3>Kontaktformular (EmailJS)</h3>
        <p>
          Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre
          Angaben aus dem Anfrageformular inklusive der von Ihnen dort
          angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den
          Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir
          nicht ohne Ihre Einwilligung weiter.
        </p>
        <p>
          Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1
          lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags
          zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen
          erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf
          unserem berechtigten Interesse an der effektiven Bearbeitung der an
          uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer
          Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt
          wurde. Die Einwilligung ist z. B. durch ein Häkchen im Formular
          dokumentiert und jederzeit mit Wirkung für die Zukunft widerrufbar.
        </p>
        <p>
          Für die technische Übermittlung der Nachrichten nutzen wir den Dienst{" "}
          <strong>EmailJS</strong>
          (EmailJS.com Ltd., Großbritannien). EmailJS handelt in unserem Auftrag
          und wir haben einen
          <strong>Vertrag zur Auftragsverarbeitung (AVV)</strong> mit dem
          Anbieter geschlossen. EmailJS empfängt Ihre Formulardaten, setzt
          jedoch keine Cookies auf Ihrem Endgerät und speichert keine Activity
          Logs. Daten können beim Versand durch Subunternehmer von EmailJS
          (Amazon Web Services, Cloudflare, Sentry, Zendesk) verarbeitet werden,
          was eine Übermittlung in die USA nach sich ziehen kann. Die
          Datenübermittlung in die USA und das Vereinigte Königreich stützt sich
          auf die Standardvertragsklauseln (SCC) der EU-Kommission,
          Angemessenheitsbeschlüsse und das EU-US Data Privacy Framework.
        </p>

        <h3>Friendly Captcha</h3>
        <p>
          Zum Schutz vor automatisierten Spam-Nachrichten verwenden wir{" "}
          <strong>Friendly Captcha</strong>
          (Friendly Captcha GmbH, Brienner Str. 45a–d, 80333 München). Friendly
          Captcha setzt
          <strong>keine Cookies</strong>, erstellt kein Nutzerprofil und
          verwendet keine Fingerprinting-Methoden. Das CAPTCHA basiert auf einem
          rechenbasierten Rätsel (Proof-of-Work), das im Browser gelöst wird.
          Dabei wird Ihre IP-Adresse temporär an Server von Friendly Captcha
          innerhalb der EU übermittelt. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f
          DSGVO (berechtigtes Interesse an der Verhinderung von Spam). Weitere
          Informationen finden Sie in der Datenschutzerklärung von Friendly
          Captcha:{" "}
          <a
            href="https://friendlycaptcha.com/legal/privacy-end-users/"
            target="_blank"
            rel="noopener noreferrer"
          >
            friendlycaptcha.com/legal/privacy-end-users
          </a>
        </p>

        <p style={{ marginTop: 24, fontSize: 12, opacity: 0.6 }}>
          Stand:{" "}
          {new Date().toLocaleDateString("de-DE", {
            month: "long",
            year: "numeric",
          })}
        </p>
      </Modal>
    </div>
  );
}

export default AppFooter;
